/* unplugin-vue-components disabled */import { render } from "./institution.vue?vue&type=template&id=e2b2b2a8&scoped=true"
import script from "./institution.vue?vue&type=script&lang=js"
export * from "./institution.vue?vue&type=script&lang=js"

import "./institution.vue?vue&type=style&index=0&id=e2b2b2a8&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/zhishiOfficialweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b2b2a8"]])

export default __exports__